import { create } from 'zustand';

/**
 * A page's own document title (e.g. the job title on /jobs/:id), set through usePageTitle.
 * DocumentTitle shows it in place of the route's default title while it is set.
 */
interface PageTitleState {
  title: string | null;
}

export const usePageTitleStore = create<PageTitleState>(() => ({ title: null }));
